import React from 'react';

function Home() {
  return <div className="App">Hello World</div>;
}

export default Home;
